export default __webpack_public_path__ + "static/media/contract.df9eddc1.svg";